import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addRoleFailure,
  addRoleSuccess,
  deleteRoleFailure,
  //
  deleteRoleSuccess,
  editRoleFailure,
  //
  editRoleSuccess,
  fetchHistoryFailure,
  fetchHistorySuccess,
  //
  fetchRole as fetchRoleAction,
  fetchRoleFailure,
  fetchRoleSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  searchEmpRolesFailure,
  searchEmpRolesSuccess,
  //
  searchRolesFailure,
  searchRolesSuccess,
  setRolesFailure,
  setRolesSuccess,
  updateSeqFailure,
  updateSeqSuccess,
} from "./actions";
import {
  ADD_ROLES,
  DELETE_ROLES,
  EDIT_ROLES,
  FETCH_HISTORY,
  FETCH_ROLES,
  GET_VIEW_DATA,
  SEARCH_EMP_ROLES,
  SEARCH_ROLES,
  SET_ROLE,
  UPDATE_SEQ,
} from "./constants";
import { getViewData } from "../Employee/actions";

export function* fetchRoleSaga({ payload = { cancelToken: null }, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee-role?${query}`,
      payload
    );
    yield put(fetchRoleSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(fetchRoleFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching role!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee-role/${payload}`
    );
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addRoleSaga({ payload, history }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/employee-role/add`, payload);
    if (data) {
      yield put(successAlert("Role added successfully!"));
      yield put(addRoleSuccess());
      history.push("/d/hr/roles");
    }
  } catch (e) {
    yield put(addRoleFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editRoleSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/employee-role/edit/${payload.id}`,
      payload
    );
    if (data) {
      yield put(successAlert("Role updated successfully!"));
      yield put(editRoleSuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(editRoleFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteRoleSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const user = yield select((state) => state?.AuthReducer?.user);

  try {
    const data = yield call(api(token).delete, `/api/employee-role/${payload}`);
    if (data) {
      yield put(successAlert("Role deleted successfully!"));
      yield put(deleteRoleSuccess());
      yield put(fetchRoleAction());
    }
  } catch (e) {
    yield put(deleteRoleFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* searchRoleSaga({ payload, onSearchSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/employee-role?${query}`);
    yield put(searchRolesSuccess(data));
    typeof onSearchSuccess === "function" && onSearchSuccess(data);
  } catch (e) {
    yield put(searchRolesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* setRoleSaga({ payload, onSearchSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).post,
      `/api/role-assign/add`,
      payload
    );
    yield put(setRolesSuccess(data));
    yield put(getViewData(payload.employee_id));
  } catch (e) {
    yield put(setRolesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* updateSeqSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/role-sequence`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Role updated successfully!"));
      yield put(updateSeqSuccess());
      typeof onSuccess === "function" && onSuccess();
    }
  } catch (e) {
    yield put(updateSeqFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* searchEmpRoleSaga({ payload, onSearchSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/search-employee-roles/${payload}`
    );
    yield put(searchEmpRolesSuccess(data));
    typeof onSearchSuccess === "function" && onSearchSuccess(data);
  } catch (e) {
    yield put(searchEmpRolesFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchHistorySaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/employee-role-History/${payload?.id}`
    );
    yield put(fetchHistorySuccess(data));
  } catch (e) {
    yield put(fetchHistoryFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching list!"));
  }
}

export function* fetchRoleFlow() {
  yield takeEvery(FETCH_ROLES, fetchRoleSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addRoleFlow() {
  yield takeEvery(ADD_ROLES, addRoleSaga);
}
export function* editRoleFlow() {
  yield takeEvery(EDIT_ROLES, editRoleSaga);
}
export function* deleteRoleFlow() {
  yield takeEvery(DELETE_ROLES, deleteRoleSaga);
}
export function* searchRoleFlow() {
  yield takeEvery(SEARCH_ROLES, searchRoleSaga);
}
export function* setRoleFlow() {
  yield takeEvery(SET_ROLE, setRoleSaga);
}
export function* updateSeqFlow() {
  yield takeEvery(UPDATE_SEQ, updateSeqSaga);
}
export function* searchEmpRoleFlow() {
  yield takeEvery(SEARCH_EMP_ROLES, searchEmpRoleSaga);
}
export function* fetchHistoryFlow() {
  yield takeEvery(FETCH_HISTORY, fetchHistorySaga);
}
export default function* RosterRoleSaga() {
  yield all([
    fetchRoleFlow(),
    addRoleFlow(),
    editRoleFlow(),
    deleteRoleFlow(),
    getViewDataFlow(),
    searchRoleFlow(),
    setRoleFlow(),
    updateSeqFlow(),
    searchEmpRoleFlow(),
    fetchHistoryFlow(),
  ]);
}
